import { render, staticRenderFns } from "./department-item.vue?vue&type=template&id=febf6228&scoped=true"
import script from "./department-item.vue?vue&type=script&lang=js"
export * from "./department-item.vue?vue&type=script&lang=js"
import style0 from "./department-item.vue?vue&type=style&index=0&id=febf6228&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "febf6228",
  null
  
)

export default component.exports